import React, { useState } from 'react';
import LomavisCard1 from '../../../generic/cards/LomavisCard1/LomavisCard1';
import LomavisButtonToggle1 from '../../../generic/buttons/LomavisButtonToggle1';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalConfiguration } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import {
  TARGET_PUBLISH_WITH_SCHEDULE,
  TARGET_SAVE_AS_APPROVED_POST
} from '../../../../redux/slices/LomavisPostApproval/constants';

const ApprovalTargetCard: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    featuresEnabled,
    data: { target }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const onFlowChange = (value: string): void => {
    dispatch(setApprovalConfiguration({ key: 'target', value }));
  };

  return (
    <LomavisCard1
      title={t('lomavisPostApproval.approvalTarget.title')}
      helpText={t('lomavisPostApproval.approvalTarget.helpText')}
    >
      <LomavisButtonToggle1
        buttonLeftFaIconClass="fa-duotone fa-solid fa-calendar-alt"
        buttonLeftText={t(
          'lomavisPostApproval.approvalTarget.publishWithSchedule'
        )}
        buttonLeftValue={TARGET_PUBLISH_WITH_SCHEDULE}
        buttonRightFaIconClass="fa-duotone fa-solid fa-layer-group"
        buttonRightText={t('lomavisPostApproval.approvalTarget.saveAsApproved')}
        buttonRightValue={TARGET_SAVE_AS_APPROVED_POST}
        buttonRightShowUpgrade={!featuresEnabled.approvalProcessSaveAsApprovedPost}
        value={target}
        onChange={onFlowChange}
      />
    </LomavisCard1>
  );
};

export default ApprovalTargetCard;
